export default "__VITE_ASSET__Ds35vZF$__"